"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportHistorySchemaProperties = exports.ExportHistorySchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.ExportHistorySchema = base_schema_1.BaseSchema.extend({
    organizationId: zod_1.z.string(),
    integrationId: zod_1.z.string(),
    executionId: zod_1.z.string(),
    status: zod_1.z
        .enum(["PENDING", "RUNNING", "SUCCEEDED", "FAILED", "CANCELLED", "UNKNOWN"])
        .optional(),
    startTime: zod_1.z.date().optional(),
    completionTime: zod_1.z.date().optional(),
});
exports.ExportHistorySchemaProperties = {
    collectionName: "exportHistory",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=export-history-schema.js.map